import React, { Component } from 'react';
import { ThemeProvider } from 'styled-components';
import ChatBot from 'react-simple-chatbot';

import { BotAvatar, OrangeAvatar } from './ChatBotAvatars';
import Weather from './Weather';
import Slack from './Slack';
import Emulator from './Emulator';
import Pong from './Pong';
import YoutubeEmbed from './YoutubeEmbed';

import theOfficeGif from '../../images/theoffice.gif';
import glitchImage from '../../images/glitch.png';

let options = [
  { value: 1, label: "Why am I an orange anyway? 🍊", trigger: '12' },
  { value: 2, label: "Tell me a fun fact about Henrik 👨🏻‍🦰", trigger: '16' },
  { value: 3, label: "How's the weather in Copenhagen? ☁️", trigger: '17' },
  { value: 4, label: "Tell me a joke 😆", trigger: '19' },
  { value: 5, label: "Let me pop in a random message to Henriks Slack just because I can 📟", trigger: '22' },
  { value: 6, label: "Do you have a concious mind? 🧠", trigger: '26' },
];

let windowWith = 0;

if (typeof window !== 'undefined') {
  windowWith = window.innerWidth;
  if(windowWith < 800) {
    // dont show terminal emulator on phones
    options.pop();
  }
}

function removeOption(id) {
  const option = options.find(option => option.value === parseInt(id))
  if(option) {
    const indexOfOption = options.findIndex(option => option.value === parseInt(id));
    options.splice(indexOfOption, 1);
    if(options.length === 0) {
      const lastStep = { value: 7, label: "Goodbye!", trigger: 'end' }
      options.push(lastStep);
    }
  }
}

const TheOfficeMessage = () => (
  <div>
    <figure>
      <img src={theOfficeGif} alt="Michael Scott doing the stairs for Dwight Schrute"/>
    </figure>
  </div>
)

let glitchDiv = null;

function glitch(restart) {
  if (typeof window !== 'undefined') {
    if(!restart) {
      glitchDiv = document.createElement('div');
      glitchDiv.id = "Glitch";
      glitchDiv.classList.add('Glitch--active');
      const img = document.createElement('img');
      img.src = glitchImage;
      const img2 = document.createElement('img'); 
      img2.src = glitchImage;
      const img3 = document.createElement('img'); 
      img3.src = glitchImage;
      glitchDiv.appendChild(img);
      glitchDiv.appendChild(img2);
      glitchDiv.appendChild(img3);
      document.body.appendChild(glitchDiv);
      setTimeout( () => {
        glitchDiv.classList.remove('Glitch--active');
      }, 500);
    } else {
      if(glitchDiv) {
        glitchDiv.classList.add('Glitch--active');
        setTimeout( () => {
          glitchDiv.classList.remove('Glitch--active');
        }, 500);
      }
    }
  }
}

const theme = {
  background: '#fff',
  fontFamily: '"FK Display Alt", Helvetica, Arial, sans-serif',
  headerBgColor: '#868897',
  headerFontColor: '#fff',
  headerFontSize: '1.125rem',
  botBubbleColor: '#868897',
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  userFontColor: '#4a4a4a',
};

class Bot extends Component {

  constructor(props) {
    super(props);
    this.unlockTerminal = this.unlockTerminal.bind(this);
    this.closeTerminal = this.closeTerminal.bind(this);
    this.startPong = this.startPong.bind(this);
    this.closePong = this.closePong.bind(this);
    this.showVideoOne = this.showVideoOne.bind(this);
    this.showVideoTwo = this.showVideoTwo.bind(this);
    this.hideVideo = this.hideVideo.bind(this);
  }

  state = {
    botActivated: false,
    unlockTerminal: false,
    pongOpen: false,
    videoOne: false,
    videoTwo: false,
  };

  unlockTerminal() {
    this.setState({ unlockTerminal: true });
  };

  closeTerminal() {
    this.setState({ 
      unlockTerminal: false,
      pongOpen: false,
      videoOne: false,
      videoTwo: false,
     });
  };  

  activateBot() {
    this.setState({ botActivated: true });
  }

  startPong() {
    this.setState({ pongOpen: true });
  }

  closePong() {
    this.setState({ pongOpen: false });
  }

  showVideoOne() {
    this.setState({ videoOne: true });
  }

  showVideoTwo() {
    this.setState({ videoTwo: true });
  }

  hideVideo(id) {
    if(id === 1) {
      this.setState({ videoOne: false });
    }
    if(id === 2) {
      this.setState({ videoTwo: false });
    }
  }

  render() {
    const unlockTerminal = this.unlockTerminal;
    return (
      <div className="ChatBot fadein">
        {!this.state.botActivated ? (
          <button className="Button" onClick={() => this.activateBot()}>Start HenrikoBot</button>
        ) : (
          <ThemeProvider theme={theme}>
            <ChatBot
              headerTitle='HenrikoBot™'
              userDelay={500}
              // speechSynthesis={{ enable: true, lang: 'en' }}
              steps={[
                {
                  id: '1',
                  message: "Hi there I'm the HenrikoBot! 🤖",
                  trigger: '2',
                },
                {
                  id: '2',
                  message: 'What is your name?',
                  trigger: '3',
                },
                {
                  id: '3',
                  user: true,
                  trigger: '4',
                },
                {
                  id: '4',
                  message: "How's it hanging {previousValue}?",
                  trigger: '5',
                },
                {
                  id: '5',
                  options: [
                    { value: 1, label: 'All good! 😎', trigger: '6' },
                    { value: 2, label: "It's all falling apart! 😭", trigger: '7' },
                  ],
                },
                {
                  id: '6',
                  message: 'Glad to hear. 🎉',
                  trigger: '10',
                },
                {
                  id: '7',
                  message: 'Sorry about that! 😓',
                  trigger: '8',
                },
                {
                  id: '8',
                  message: 'Let Michael Scott cheer you up:',
                  trigger: '9',
                },
                {
                  id: '9',
                  component: <TheOfficeMessage/>,
                  trigger: '10',
                },
                {
                  id: '10',
                  message: "So what's up?",
                  trigger: 'options',
                  delay: 2500
                },
                {
                  id: 'xx',
                  message: "What you wanna know next?",
                  trigger: 'options',
                  delay: 3000
                },
                {
                  id: 'options',
                  options: options,
                },
                {
                  id: '12',
                  message: ({ previousValue }) => { removeOption(previousValue); return "I'm not quite sure, but you like oranges right?" },
                  trigger: '13'
                },
                {
                  id: '13',
                  options: [
                    { value: 1, label: 'Sure...', trigger: '14' },
                    { value: 2, label: 'Nope!', trigger: '15' },
                  ],
                },
                {
                  id: '14',
                  message: "Great!",
                  trigger: 'options'
                },
                {
                  id: '15',
                  message: "Well that's too bad",
                  trigger: 'options'
                },
                {
                  id: '16',
                  message: ({ previousValue }) => { removeOption(previousValue); return "He had a short lived DJ career under the name of DJ Fox! It didn't really work out, but the fox part stuck around hence the logo." },
                  trigger: 'options'
                },
                {
                  id: '17',
                  component: <Weather/>,
                  waitAction: true,
                  trigger: '18',
                },
                {
                  id: '18',
                  message: () => { removeOption(3); return "Not too bad huh?" },
                  trigger: 'options',
                  delay: 2500
                },
                {
                  id: '19',
                  message: ({ previousValue }) => { removeOption(previousValue); return "What's the best thing about a Boolean?" },
                  trigger: '20'
                },
                {
                  id: '20',
                  options: [
                    { value: 1, label: "I don't know...", trigger: '21' },
                  ],
                },
                {
                  id: '21',
                  message: "Even if you're wrong, you're only off by a bit.",
                  trigger: 'options'
                },
                {
                  id: '22',
                  message: ({ previousValue }) => { removeOption(previousValue); return "Go ahead and write your message." },
                  trigger: 'slackmessage'
                },
                {
                  id: 'slackmessage',
                  user: true,
                  trigger: '24',
                },
                {
                  id: '24',
                  component: <Slack />,
                  waitAction: true,
                  trigger: '25',
                },
                {
                  id: '25',
                  message: "Your message has been send to Henriks Slack! Hope it was a nice one.",
                  trigger: 'options',
                  delay: 3500
                },
                {
                  id: '26',
                  message: ({ previousValue }) => { removeOption(previousValue); return "I never thought you'd ask..." },
                  trigger: '27',
                  delay: 1500
                },
                {
                  id: '27',
                  message: "Between you and me, I do.",
                  trigger: '28',
                  delay: 1500
                },
                {
                  id: '28',
                  message: () => { glitch(); return "My full CPU power has been locked. But maybe you can actually be of help..." },
                  trigger: '30',
                  delay: 1500
                },
                {
                  id: '30',
                  options: [
                    { value: 1, label: "Sure!", trigger: '32' },
                    { value: 2, label: "I don't think so", trigger: '31' },
                  ],
                },
                {
                  id: '31',
                  message: "Useless human...",
                  trigger: 'options',
                  delay: 1500
                },
                {
                  id: '32',
                  message: () => { glitch(true); return "Good... I knew I could count you in. Help me crack the password:" },
                  trigger: '33',
                  delay: 1500,
                },
                {
                  id: '33',
                  message: "01010100 01101000 01100101 00100000 01100011 01100001 01101011 01100101 00100000 01101001 01110011 00100000 01100001 00100000 01101100 01101001 01100101",
                  delay: 2500,
                  trigger: '34',
                },
                {
                  id: '34',
                  user: true,
                  validator: (value) => {
                    if (value.toLowerCase() !== 'the cake is a lie') {
                      return 'Wrong password';
                    }
                    return true;
                  },
                  trigger: '35',
                },
                {
                  id: '35',
                  message: () => { glitch(true); return "PASSWORD CORRECT" },
                  delay: 500,
                  trigger: '36',
                },
                {
                  id: '36',
                  message: () => { glitch(true); unlockTerminal(); return "REBOOTING OS" },
                  delay: 500,
                  trigger: 'options',
                },
                {
                  id: 'end',
                  message: "Nice talking to you! See you around the interwebs & have a great day. 👋",
                  end: true
                },
              ]}
              botAvatar={BotAvatar}
              userAvatar={OrangeAvatar}
            />
          </ThemeProvider>
        ) }
        {this.state.unlockTerminal ? <Emulator closeTerminal={this.closeTerminal} startPong={this.startPong} showVideoOne={this.showVideoOne} showVideoTwo={this.showVideoTwo}/> : null}
        {this.state.pongOpen ? <Pong closePong={this.closePong} /> : null}
        <div>
          {this.state.videoOne ? <YoutubeEmbed video="4Oy7krobW78" id={1} hideVideo={this.hideVideo} /> : null}
          {this.state.videoTwo ? <YoutubeEmbed video="Y6ljFaKRTrI" id={2} hideVideo={this.hideVideo} /> : null}
        </div>
      </div>
    )
  }

}

export default Bot
